import React from 'react';
import _get from "lodash/get";
/*ui*/
import { makeStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import priceWithVAT from "../../../helpers/priceWithVAT";
/*component*/
import listingCardGeneralStyles from "../../../theme/listingCardGeneralStyles";
import toLocale from "../../../helpers/toLocale";

const useStyles = makeStyles((theme) => ({
    ...listingCardGeneralStyles(theme),
    price: {
        fontSize: `1.125rem`,
        fontWeight: 500,
        lineHeight: 1.2,
        marginBottom: theme.spacing(1)
    },
    tva:{
        display: 'inline-block',
        fontSize: theme.typography.pxToRem(10),
        lineHeight: '100%',
        letterSpacing: '0%',
        verticalAlign: 'middle',
        fontWeight: 'bold',
        marginBottom: '7px'
    },
    totalPrice: {
        fontSize: 14,
        fontWeight: 500,
        paddingTop: theme.spacing(0.5),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    oldTva:{
        display: 'inline-block',
        fontSize: theme.typography.pxToRem(8),
        lineHeight: '100%',
        letterSpacing: '0%',
        verticalAlign: 'middle',
        textDecoration: 'line-through',
    }
}))


/**
 * Confused it with price renderer from search list
 * Leaving this functional component even if it has one usage
 */
const DetailsCarPrice = (carData) => {
    const classes = useStyles();

    if (!carData.final_offer_price_with_vat) return;

    // const priceWithVAT = carData.client_invoice_price * 1.19;

    const showDiscountPrice = +_get(carData,'final_discount_percentage',0) > 0 ;

    if (!showDiscountPrice) {

        return <div className={`${classes.noOldPrice} ${classes.price} ${classes.weight700}`}>
                {toLocale(_get(carData,'final_offer_price_with_vat'))}€ <span className={classes.tva}>TVA <br />inclus</span>
        </div>

    } else {
        return (
            <React.Fragment>
                <div>
                    <span className={`${classes.price}`}>
                        {toLocale(_get(carData,'final_offer_price_with_vat'))}€  <span className={classes.tva}>TVA <br />inclus</span>
                        <span className={classes.oldPriceDiscount}>
                            (-{`${toLocale(_get(carData, "final_discount_percentage", ""))}`}%)
                        </span>
                    </span>
                    <Typography align={"left"} component={"div"} variant="caption" className={classes.oldPrice}>
                        <span className={`${classes.lineThrough} ${classes.totalPrice}`}>
                            {toLocale(_get(carData,'total_price_with_vat',''))}€ <span className={classes.oldTva}>TVA <br />inclus</span>
                        </span>
                    </Typography>
                </div>
            </React.Fragment>
        )
    }
}

export default DetailsCarPrice;
